<template>
  <v-card>
    <v-card-title primary-title class="justify-center">
      <div>
        <div class="display-1 font-weight-medium blue--text">
          <v-icon large>supervised_user_circle</v-icon>
          User
        </div>
        <center>
          <span class="subheading green--text">Activate</span>
        </center>
      </div>
    </v-card-title>
    <v-card-text>
      <v-flex xs10 offset-xs1>
        <v-container fluid grid-list-md>
          <v-layout row wrap>
            <v-flex xs10>
              <v-text-field
                class="mx-3"
                background-color="blue lighten-5"
                outline
                label="User ID"
                v-model.trim="searchUserID"
                append-icon="search"
                @click:append="findUser"
                @keydown.enter.prevent="findUser"
                clearable
                maxlength="34"
              ></v-text-field> 
            </v-flex>
            <v-flex xs2 align-center text-xs-center>
              <img src="~assets/images/scan_qrcode.png" class="cursor" @click="scanQrcode">
            </v-flex>
            <v-flex xs12 align-center text-xs-center>
              <p class="error">{{ error }}</p>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-card-text>
    <v-dialog v-model="execResultDialog" width="600px">
      <v-card class="modal-detail">
        <v-card-text>
          <v-container align-center grid-list-md text-md-center>
            <v-layout row wrap>
              <v-flex xs12>
                <span class="font-weight-medium my-2 headline font-italic">
                  Activate User
                </span>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <p>
                  Do you want to activate the user <b>{{ this.userFullName }}</b> with the ID <b>{{ this.searchUserID }}</b>?
                </p>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 text-xs-center>
                <v-btn color="success" @click.native="send">
                  Activate
                  <v-icon right dark>how_to_reg</v-icon>
                </v-btn>
              </v-flex>
              <v-flex xs6 text-xs-center>
                <v-btn color="info" @click.native="execResultDialog = false">
                  Cancel
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="qrScan" max-width="50%">
      <v-container>
        <v-layout>
          <v-flex xs12 align-center text-xs-center>
            <qrcode-stream :track="false" @decode="onDecode" @init="onInit" :camera="camera" v-if="qrComponent" />
          </v-flex>
        </v-layout>    
      </v-container>
    </v-dialog>
    <v-dialog v-model="confirmSendDialog" persistent max-width="50%">
      <v-card>
        <v-card-title>
          <span class="headline">
          {{ $t('send_to_contract.confirm') }}
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-textarea label="Raw Tx" v-model="rawTx" disabled></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="blue--text darken-1" flat @click="confirmSend" v-show="canSend && !sending">{{ $t('common.confirm') }}</v-btn>
          <v-btn class="red--text darken-1" flat @click.native="confirmSendDialog = false" :v-show="!sending">{{ $t('common.cancel') }}</v-btn>
          <v-progress-circular indeterminate :size="50" v-show="sending" class="primary--text"></v-progress-circular>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<style scoped>
  .error {
    font-weight: bold;
    color: red;
  }

  .cursor:hover {
    cursor: pointer;
  }

  .modal-detail {
    background-image: url("~assets/images/myoffspring_border.png");
  }
</style>

<script>
  import webWallet from 'libs/web-wallet'
  import abi from 'ethjs-abi'
  import server from 'libs/server'
  import config from 'libs/config'
  import sha256 from 'js-sha256'
  import base58 from 'bs58'

  import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'

  const contractAddress = config.getNetwork() == "mainnet" ? "1184387fabba8058e3094dbb489be214dba4b770" : "0";

  const abiJson = JSON.parse(
    '[{"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_facilityType", "type": "uint8"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserFacilityDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_newLimit", "type": "uint8"} ], "name": "setFacilitiesLimit", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_physicianUserAddress", "type": "address"} ], "name": "getPhysicianFacilitiesTotal", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "invalidateUser", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "checkPhysician", "outputs": [{"name": "isPhysician", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "getFacilitiesLimit", "outputs": [{"name": "", "type": "uint8"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_physicianUserAddress", "type": "address"}, {"name": "_facilityUserAddress", "type": "address"} ], "name": "addPhysicianToFacility", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [{"name": "_physicianUserAddress", "type": "address"}, {"name": "_facilityUserAddress", "type": "address"} ], "name": "removePhysicianfromFacility", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "isUserValid", "outputs": [{"name": "", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "", "type": "address"} ], "name": "usersAccessLevels", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "checkFacility", "outputs": [{"name": "isFacility", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserFacilityType", "outputs": [{"name": "", "type": "uint8"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "activateUser", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_physicianUserAddress", "type": "address"} ], "name": "getPhysicianFacilities", "outputs": [{"name": "facility1", "type": "address"}, {"name": "facility1Name", "type": "string"}, {"name": "facility2", "type": "address"}, {"name": "facility2Name", "type": "string"}, {"name": "facility3", "type": "address"}, {"name": "facility3Name", "type": "string"}, {"name": "facility4", "type": "address"}, {"name": "facility4Name", "type": "string"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_userType", "type": "uint8"}, {"name": "_userFullName", "type": "string"}, {"name": "_userEmail", "type": "string"}, {"name": "_userPhysicalAddress", "type": "string"}, {"name": "_userPhone", "type": "uint256"}, {"name": "_PRC", "type": "uint256"}, {"name": "_PRCExpDate", "type": "uint256"}, {"name": "_PTR", "type": "uint256"}, {"name": "_PTRExpDate", "type": "uint256"}, {"name": "_S2", "type": "uint256"}, {"name": "_S2ExpDate", "type": "uint256"}, {"name": "_userAccessLevel", "type": "uint8"} ], "name": "setUserPhysicianDetails", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserPhysicianDetails", "outputs": [{"name": "PRC", "type": "uint256"}, {"name": "PRCExpDate", "type": "uint256"}, {"name": "PTR", "type": "uint256"}, {"name": "PTRExpDate", "type": "uint256"}, {"name": "S2", "type": "uint256"}, {"name": "S2ExpDate", "type": "uint256"}, {"name": "updatedBy", "type": "address"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserDetails", "outputs": [{"name": "userType", "type": "uint8"}, {"name": "userFullName", "type": "string"}, {"name": "userEmail", "type": "string"}, {"name": "userPhysicalAddress", "type": "string"}, {"name": "userPhone", "type": "uint256"}, {"name": "updatedBy", "type": "address"}, {"name": "valid", "type": "bool"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_newOwner", "type": "address"} ], "name": "ownershipTransfer", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": true, "inputs": [], "name": "totalDataInput", "outputs": [{"name": "", "type": "uint16"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [], "name": "totalAdmins", "outputs": [{"name": "", "type": "uint16"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": true, "inputs": [{"name": "_userAddress", "type": "address"} ], "name": "getUserAccessLevel", "outputs": [{"name": "", "type": "uint256"} ], "payable": false, "stateMutability": "view", "type": "function"}, {"constant": false, "inputs": [{"name": "_userAddress", "type": "address"}, {"name": "_accessLevel", "type": "uint8"} ], "name": "setUserAccessLevel", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"constant": false, "inputs": [], "name": "ownershipTransferConfirm", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function"}, {"inputs": [], "payable": false, "stateMutability": "nonpayable", "type": "constructor"} ]'
  );

  export default {
    data () {
      return {
        loading: false,
        error: null,
        qrScan: false,
        camera: false,
        qrComponent: false,
        gasPrice: '40',
        gasLimit: '2500000',
        fee: '0.01',
        confirmSendDialog: false,
        execResultDialog: false,
        rawTx: 'loading...',
        canSend: false,
        sending: false,
        searchUserID: '',
        userFullName: '',
        qr: ''
      }
    },
    components:{
      QrcodeStream,
      QrcodeCapture
    },
    watch: {
      qrScan(val){
        if(!val)
          this.camera = false;
      }
    },
    methods: {
      scanQrcode(){
        this.searchUserID = '';
        this.qrComponent = true;
        this.camera = true;
        this.qrScan = true;
      },

      onDecode(userID) {
        this.searchUserID = userID;
        this.camera = false;
        this.qrScan = false;
        this.findUser();
      },

      async onInit (promise) {
        try {
          await promise
        } catch (error) {
          if (error.name === 'NotAllowedError') {
            this.error = "ERROR: you need to grant camera access permisson";
          } else if (error.name === 'NotFoundError') {
            this.error = "ERROR: no camera on this device";
          } else if (error.name === 'NotSupportedError') {
            this.error = "ERROR: secure context required (HTTPS, localhost)";
          } else if (error.name === 'NotReadableError') {
            this.error = "ERROR: is the camera already in use?";
          } else if (error.name === 'OverconstrainedError') {
            this.error = "ERROR: installed cameras are not suitable";
          } else if (error.name === 'StreamApiNotSupportedError') {
            this.error = "ERROR: Stream API is not supported in this browser";
          }
        }
      },

      async send() {
        try {
          const hexAddress = '0x' + base58.decode(this.searchUserID).toString('hex').substr(2, 40);
          var encodedData = this.encodeContractSendFunction(
            abiJson, 
            'activateUser', 
            [hexAddress]
          );

          this.execResultDialog = false;
          this.confirmSendDialog = true;

          try {
            this.rawTx = await webWallet.getWallet().generateSendToContractTx(contractAddress, encodedData, this.gasLimit, this.gasPrice, this.fee);
          } catch (e) {
            this.$root.log.error('send_to_generate_tx_error', e.stack || e.toString() || e);
            alert(e.message || e);
            this.confirmSendDialog = false;
            return false;
          }
          this.canSend = true
        } catch (e) {
          this.$root.error('Params error');
          this.$root.log.error('send_to_contract_encode_abi_error', e.stack || e.toString() || e);
          this.confirmSendDialog = false;
          return false;
        }
      },

      async confirmSend() {
        this.sending = true;
        try {
          const txId = await webWallet.getWallet().sendRawTx(this.rawTx);
          this.confirmSendDialog = false;
          this.sending = false;
          const txViewUrl = server.currentNode().getTxExplorerUrl(txId);
          this.$root.success(`Successful sent! You can follow the transaction on <a href="${txViewUrl}" target="_blank">${txViewUrl}</a>`, true, 0);
          this.$emit('send');
        } catch (e) {
          alert(e.message || e);
          this.$root.log.error('send_to_contract_post_raw_tx_error', e.response || e.stack || e.toString() || e);
          this.confirmSendDialog = false;
        }
      },

      async findUser() {
        if(this.searchUserID == '' || !(/^[a-zA-Z0-9]{34}$/.test(this.searchUserID))) {
          alert('Please inform a valid User ID.');
        } else {
          this.loading = true;
          try {

            const hexAddress = '0x' + base58.decode(this.searchUserID).toString('hex').substr(2, 40);
            var decodedResult = await this.callContractFunction(
              contractAddress, 
              abiJson, 
              'getUserDetails', 
              [hexAddress]
            );

            this.loading = false;

            if(decodedResult[6].toString() == 'true'){
              alert('The user is already active.');
            } else {
              this.userFullName = decodedResult[1].toString();
              this.execResultDialog = true;
            }
            
          } catch (e) {
            this.loading = false;
            this.$root.error('Params error');
            this.$root.log.error('call_contract_encode_abi_error', e.stack || e.toString() || e);
            return false;
          }
        }
      },

      findIndexByName(abiJson, name){
        return abiJson.findIndex(function(item){
          return item.name === name
        });
      },

      async callContractFunction(contractAddress, abiJson, functionName, params){
        const encodedData = abi.encodeMethod(
          abiJson[
            this.findIndexByName(
              abiJson,
              functionName
            )
          ], 
          params
        ).substr(2);
        var encodedResult = await webWallet.getWallet().callContract(contractAddress, encodedData);          
        encodedResult = '0x' + encodedResult;

        return abi.decodeMethod(abiJson[this.findIndexByName(abiJson,functionName)], encodedResult);
      },

      encodeContractSendFunction(abiJson, functionName, params){
        return abi.encodeMethod(
          abiJson[this.findIndexByName(abiJson, functionName)], 
          params
        ).substr(2);
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/controllers/User-Activate.vue